import { render } from "./index.vue?vue&type=template&id=55ba161e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Settings/Account/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55ba161e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55ba161e', __exports__)) {
    api.reload('55ba161e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=55ba161e", () => {
    api.rerender('55ba161e', render)
  })

}


export default __exports__